/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

$(function () {
    function initContactEvents() {
        let $section = $('.section-contact');
        if(!$section.length){
            return;
        }

        let $contactTime = $section.find('[name="ContactPhoneForm[contactTime]"]');
        let $timeSchedule = $section.find('[name="ContactPhoneForm[timeSchedule]"]');

        $contactTime.change(function () {
            $timeSchedule.closest('.form-group').hide();

            if($contactTime.val()=='schedule'){
                $timeSchedule.closest('.form-group').show();
            }
        }).change();

        $section.find('.contact-messenger').click(function(){
            $('html').addClass('messenger-opened');
        });
    }

    initContactEvents();
});